var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId, tokens, useBreakpoint } from '@airtel/air-design-system';
import { View } from 'react-native';
export var withSpacer = Component => {
  var Wrapper = props => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _props$showSpacer = props.showSpacer,
      showSpacer = _props$showSpacer === void 0 ? false : _props$showSpacer,
      _props$spacerProps = props.spacerProps,
      spacerProps = _props$spacerProps === void 0 ? {} : _props$spacerProps,
      restProps = __rest(props, ["showSpacer", "spacerProps"]);
    var _useBreakpoint = useBreakpoint({
        returnAsObject: true
      }),
      isLargeScreen = _useBreakpoint.isLargeScreen;
    var spacing = {
      marginTop: (_a = tokens.spacing) === null || _a === void 0 ? void 0 : _a[isLargeScreen ? (_b = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.top) === null || _b === void 0 ? void 0 : _b.desktop : (_c = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.top) === null || _c === void 0 ? void 0 : _c.mobile],
      marginRight: (_d = tokens.spacing) === null || _d === void 0 ? void 0 : _d[isLargeScreen ? (_e = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.right) === null || _e === void 0 ? void 0 : _e.desktop : (_f = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.right) === null || _f === void 0 ? void 0 : _f.mobile],
      marginBottom: (_g = tokens.spacing) === null || _g === void 0 ? void 0 : _g[isLargeScreen ? (_h = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.bottom) === null || _h === void 0 ? void 0 : _h.desktop : (_j = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.bottom) === null || _j === void 0 ? void 0 : _j.mobile],
      marginLeft: (_k = tokens.spacing) === null || _k === void 0 ? void 0 : _k[isLargeScreen ? (_l = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.left) === null || _l === void 0 ? void 0 : _l.desktop : (_m = spacerProps === null || spacerProps === void 0 ? void 0 : spacerProps.left) === null || _m === void 0 ? void 0 : _m.mobile]
    };
    return _jsx(_Fragment, {
      children: showSpacer ? _jsx(View, Object.assign({
        style: spacing
      }, getTestId(props.testID, 'withSpacer'), {
        children: _jsx(Component, Object.assign({}, restProps, {
          spacerHocProps: spacerProps
        }))
      })) : _jsx(Component, Object.assign({}, restProps))
    });
  };
  return Wrapper;
};